import SectorHero from "@/components/SectorHero";
import RealisationsGallery from "@/components/RealisationsGallery";
import StatsBand from "@/components/StatsBand";
import TestimonialSlider from "@/components/TestimonialSlider";
import ContactSection from "@/components/ContactSection";

export default function Realisations() {
  return (
    <div data-testid="realisations-page">
      <SectorHero
        kicker="Réalisations"
        title="Des programmes qui parlent d'eux-mêmes."
        blurb="Un échantillon des projets ECONATION : industriels, tertiaires, copropriétés. Pour chaque cas, des chiffres vérifiés et un retour sur investissement mesuré."
        image="https://images.unsplash.com/photo-1565793298595-6a879b1d9492?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80"
        tags={["Industrie", "Tertiaire", "Logistique", "Santé", "Hôtellerie", "Copropriétés"]}
      />
      <RealisationsGallery />
      <StatsBand dark />
      <TestimonialSlider />
      <ContactSection />
    </div>
  );
}
